/**
 * Hero search / find-experts: no `service.category` filter (all experts in the chosen city or province-wide).
 */
export const FIND_EXPERTS_ALL_EXPERTS_LABEL = 'All Experts' as const;

/**
 * Maps what we show in the app to the exact `service.category` string stored in the database.
 * Keep `databaseCategory` in sync with `config/service_order.php` and the `service` table.
 * When copy differs from DB, set `displayName` (UI) and `databaseCategory` (API / URL `category` param).
 */
export type ServiceCategoryMappingRow = {
    /** Exact `service.category` value (Laravel `service` table). */
    databaseCategory: string;
    /** Label in Autocomplete, hero search, etc. */
    displayName: string;
};

export const SERVICE_CATEGORY_UI_MAPPINGS: readonly ServiceCategoryMappingRow[] = [
    { databaseCategory: 'Cleaning Services', displayName: 'Cleaning Services' },
    { databaseCategory: 'Home Improvement & Renovation', displayName: 'Home Improvement & Renovation' },
    { databaseCategory: 'Handyman & Repairs', displayName: 'Handyman & Repairs' },
    { databaseCategory: 'Assembly & Installation', displayName: 'Assembly & Installation' },
    { databaseCategory: 'Tech & Electronics', displayName: 'Tech & Electronics' },
    { databaseCategory: 'Moving & Hauling', displayName: 'Moving & Hauling' },
    { databaseCategory: 'Shopping & Delivery', displayName: 'Shopping & Delivery' },
    { databaseCategory: 'Auto Services', displayName: 'Auto Services' },
    { databaseCategory: 'Health, Wellness & Care', displayName: 'Health, Wellness & Care' },
    { databaseCategory: 'Pet Care', displayName: 'Pet Care' },
    { databaseCategory: 'Event Services', displayName: 'Event Services' },
    { databaseCategory: 'Seasonal & Outdoor Maintenance', displayName: 'Seasonal & Outdoor Maintenance' },
    { databaseCategory: 'Home Safety & Security', displayName: 'Home Safety & Security' },
    { databaseCategory: 'Office & Workspace', displayName: 'Office & Workspace' },
    { databaseCategory: 'Legal & Financial Services', displayName: 'Legal & Financial Services' },
    { databaseCategory: 'Education & Lessons', displayName: 'Education & Lessons' },
    { databaseCategory: 'Property & Environmental Services', displayName: 'Property & Environmental Services' },
    { databaseCategory: 'Pool & Spa Services', displayName: 'Pool & Spa Services' },
    { databaseCategory: 'Exterior & Structural', displayName: 'Exterior & Structural' },
    { databaseCategory: 'Personal & Lifestyle', displayName: 'Personal & Lifestyle' },
] as const;

export function databaseCategoryToDisplayName(databaseCategory: string): string {
    const t = databaseCategory.trim();
    const row = SERVICE_CATEGORY_UI_MAPPINGS.find((r) => r.databaseCategory === t);
    return row?.displayName ?? t;
}

/** Resolve UI / loose text to the exact DB category when a mapping row matches `displayName` (case-insensitive). */
export function displayNameToDatabaseCategory(displayName: string): string {
    const t = displayName.trim();
    const row = SERVICE_CATEGORY_UI_MAPPINGS.find(
        (r) => r.displayName.toLowerCase() === t.toLowerCase(),
    );
    return row?.databaseCategory ?? t;
}
